( function () {
   
    'use strict';

    ( function ( $ ) {
        
        // var group = $(".blog-new-slider .blog-new img");
        //     var tallest = 500;
        //     group.each(function(){
        //     var currentHeight = $(this).height(500);
        //     if(currentHeight > tallest) {
        //         tallest = currentHeight;
        //     }
        // });
        // group.height(tallest);
		//start the slider
		$('.blog-news-slider').slick({
            dots:false,
            infinite: false,
            arrows:true,
            speed: 600,
            slidesToShow: 2.1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0px',
            autoplay:false,
            autoplaySpeed: 2000,
            
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    centerPadding: '0px',
                    slidesToShow: 1,
                }
            },
            {
                breakpoint:767,
                settings: {
                    centerPadding: '0px',
                    slidesToShow: 1,
                }
            }
            ]
        })
        .on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });
        
    } )(jQuery);
} )();

